module.exports = __webpack_public_path__ + "static/media/Saudi.4edde766.png";